'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagArAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.24941e-06 1.22488e-05C9.33334 1.22488e-05 18.6667 0.000127672 28 0V20C18.6666 20 9.33329 20 -6.10352e-05 20C-3.99942e-05 13.3333 -7.81761e-05 6.66668 7.24941e-06 1.22488e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-4.22448e-06 6.66668H28V0L7.24941e-06 1.22488e-05L-4.22448e-06 6.66668Z",
          fill: "#88BBE8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.10352e-05 20H28V13.3333H-4.22448e-06L-6.10352e-05 20Z",
          fill: "#88BBE8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 12C15.1046 12 16 11.1046 16 10C16 8.89544 15.1046 8.00001 14 8.00001C12.8954 8.00001 12 8.89544 12 10C12 11.1046 12.8954 12 14 12Z",
          fill: "#F4B32E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6667 10C16.6667 11.4728 15.4728 12.6667 14 12.6667C12.5272 12.6667 11.3333 11.4728 11.3333 10C11.3333 8.52725 12.5272 7.33335 14 7.33335C15.4728 7.33335 16.6667 8.52725 16.6667 10ZM16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 8.89544 12.8954 8.00001 14 8.00001C15.1046 8.00001 16 8.89544 16 10Z",
          fill: "#DB7A2C"
        }
      )
    ]
  }
);
const VpFlagArAsset = forwardRef(FlagArAsset);

export { VpFlagArAsset as default };
